import { useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { StatusBadge } from "../components/Badges";
import KnowledgeDetail from "../components/KnowledgeDetail";

export default function DecisionLedger() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = useCallback(() => api.get("/knowledge?type=DECISION").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <PageHeader title="Decision Ledger" subtitle="Founder-approved decisions and the reasoning that governs how PRAMAANA operates." />
      <div className="p-10">
        <div className="border border-slate-200 bg-white divide-y divide-slate-100" data-testid="decision-list">
          {items.map((it, i) => (
            <button
              key={it.id}
              data-testid={`decision-item-${it.knowledge_id}`}
              onClick={() => setSelected(it.id)}
              className="w-full text-left px-6 py-5 hover:bg-slate-50 transition-colors duration-150 flex items-start gap-5 fade-in"
              style={{ animationDelay: `${i * 8}ms` }}
            >
              <span className="font-mono text-sm text-slate-700 bg-slate-100 px-2 py-0.5 rounded-sm shrink-0 mt-0.5">{it.knowledge_id}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3">
                  <h3 className="font-sans font-semibold text-slate-800">{it.title}</h3>
                  <StatusBadge status={it.status} />
                </div>
                <p className="text-sm text-slate-600 leading-relaxed mt-1">{it.statement}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
      <KnowledgeDetail itemId={selected} open={!!selected} onClose={() => setSelected(null)} onChanged={load} />
    </div>
  );
}
